"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1000;\n  height: 40px;\n  width: 40px;\n  min-height: unset;\n  min-width: unset;\n  border-radius: 50%;\n  background-color: #fff;\n  position: absolute;\n  right: 30px;\n  bottom: 10px;\n  margin: 0;\n  transform: ", ";\n  transition: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: auto;\n  scroll-behavior: smooth;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents.default.div(_templateObject());

var ChildrenContainer = _styledComponents.default.div(_templateObject2());

var TopButton = (0, _styledComponents.default)(_Button.default)(_templateObject3(), function (_ref) {
  var displaybutton = _ref.displaybutton;
  return displaybutton === 'true' ? 'none' : 'translate(0, 100px)';
}, function (props) {
  return props.theme.transitions.create('transform', {
    duration: props.theme.transitions.duration.shortest
  });
});

var ScrollContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  function ScrollContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      displaybutton: 'false'
    };
    _this.childrenContainer = _react.default.createRef();
    _this.scrollPos = 0;
    _this.checkScroll = (0, _lodash.default)(function () {
      if (_this.childrenContainer.current.scrollTop > _this.props.top && _this.state.displaybutton === 'false') {
        _this.setState({
          displaybutton: 'true'
        });
      }

      if (_this.childrenContainer.current.scrollTop < _this.props.top || _this.scrollPos > _this.childrenContainer.current.scrollTop) {
        _this.setState({
          displaybutton: 'false'
        });
      }

      _this.scrollPos = _this.childrenContainer.current.scrollTop;
    }, 200);

    _this.scrollToTop = function () {
      _this.childrenContainer.current.scrollTop = 0;
    };

    return _this;
  }

  _createClass(ScrollContainer, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(Container, null, _react.default.createElement(ChildrenContainer, Object.assign({
        innerRef: this.childrenContainer,
        onScroll: this.checkScroll
      }, this.props)), _react.default.createElement(TopButton, {
        onClick: this.scrollToTop,
        variant: "fab",
        color: "default",
        "aria-label": "KeyboardArrowUp",
        displaybutton: this.state.displaybutton
      }, _react.default.createElement(_Icon.default, {
        name: "keyboard_arrow_up"
      })));
    }
  }]);

  return ScrollContainer;
}(_react.default.Component);

ScrollContainer.defaultProps = {
  top: 20
};
var _default = ScrollContainer;
exports.default = _default;